<template>
  <header class="header">
      <ul class="navbar_nav">
        <li class="dropdown active">
          <router-link :to="{path:'/'}">
			  <img class="tabImg" src="../assets/img/tabs/about.png" />
		  </router-link>
          <div class="dropdown_menu">
            <router-link :to="{path:'/culture',query:{id:'1'}}">企业文化</router-link>
            <router-link :to="{path:'/chestnut'}">栗子文化</router-link>
            <router-link :to="{path:'/culture',query:{id:'2'}}">发展历程</router-link>
            <router-link :to="{path:'/newslist'}">公司新闻</router-link>
            <router-link :to="{path:'/enterpriser'}">企业家风采</router-link>
          </div>
        </li>
        <li class="dropdown">
          <router-link :to="{path:'/kingdom'}">
		  <img class="tabImg" src="../assets/img/tabs/king.png" />
		  </router-link>
          <div class="dropdown_menu">
            <router-link :to="{path:'/kingdom',query:{id:'1'}}">明星单品</router-link>
            <router-link :to="{path:'/kingdom',query:{id:'2'}}">坚果果干</router-link>
            <router-link :to="{path:'/kingdom',query:{id:'3'}}">凉果蜜饯</router-link>
          </div>
        </li>
        <li class="dropdown">
          <!-- <a href="javascript:void(0)"> -->
			  <router-link :to="{path:'/themelist'}">
			  <img class="tabImg" src="../assets/img/tabs/brand.png" />
			  </router-link>
			  <!-- </a> -->
          <div class="dropdown_menu">
            <router-link :to="{path:'/themelist'}">主题营销</router-link>            
            <router-link :to="{path:'/tv'}">板栗TV</router-link>            
          </div>
        </li>
        <li class="logo-center">
          <a href="/">
            <img class="logoImg" src="../assets/img/logo.png" alt />
          </a>
        </li>
        <li class="dropdown">
          <router-link :to="{path:'/join'}">
		  <img class="tabImg" src="../assets/img/tabs/join.png" />
		  </router-link>  
          <!-- <div class="dropdown_menu">
            <a href="/bejoiner">加盟政策</a>
            <a href="/besupplier">加盟条件</a>
            <a href="/beagency">在线申请</a>
          </div> -->
        </li>
        <li class="dropdown">
          <!-- <a href="javascript:void(0)">招贤纳士</a> -->
		  <router-link :to="{path:'/staff'}">
		  <img class="tabImg" src="../assets/img/tabs/job.png" />
		  </router-link>
          <div class="dropdown_menu">
             <router-link :to="{path:'/staff'}">员工风采</router-link>
            <router-link :to="{path:'/employee'}">招聘信息</router-link>
          </div>
        </li>
        <li class="dropdown">
          <!-- <a href="javascript:void(0)">联系我们</a> -->
		  <router-link :to="{path:'/store'}">
		     <img class="tabImg" src="../assets/img/tabs/call.png" />
		  </router-link>
          <div class="dropdown_menu">
             <router-link :to="{path:'/store'}">门店查询</router-link>
            <router-link :to="{path:'/headquarters'}">公司总部</router-link>
          </div>
        </li>
      </ul>
    </header>
</template>

<script>
export default {
  name: 'headerNav',
  props: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.tabImg{
	height: 25px;
	line-height: 25px;
}
.logo-center{
	width: 240px;
}
.logo-center img {
    width: 100%;
    padding: 20px 0;
}
</style>
